import { type DocumentImage } from '~/gql/graphql'

import { getMetaValue } from './internal/getMetaValue'

/**
 * DocumentImage から作成者を取得します。
 *
 * @template TDocumentImage - DocumentImageの型。
 * @param documentImage - DocumentImage。
 * @returns 作成者。
 */
export function getCreator<
  TDocumentImage extends App.PickGraphQL<DocumentImage, 'allMetadata'>,
>(documentImage: TDocumentImage): string | undefined {
  return getMetaValue(documentImage, 'creator')
}
